import { useRef, useState } from 'react';
import {
  googleAutocomplete,
  formatGooglePlacesResult,
  sendDatadogError,
} from 'lib/googleAutocomplete';

export const useGoogleAutocomplete = ({
  resultsFormatting = formatGooglePlacesResult,
  resultsLimit = 5,
  searchType = 'establishment',
} = {}) => {
  const hasNoResultsRef = useRef(false);
  const [placePredictions, setPlacePredictions] = useState([]);

  const clearPredictions = () => setPlacePredictions([]);

  const getAutocompletePredictions = (searchTerm) => {
    googleAutocomplete(searchTerm, searchType)
      .then((results) => {
        if (results?.length > 0) {
          let limitedResults = [...results];
          limitedResults.length = resultsLimit;

          setPlacePredictions(
            resultsFormatting ? limitedResults.map(resultsFormatting) : results
          );
          hasNoResultsRef.current = false;
        } else {
          hasNoResultsRef.current = true;
          clearPredictions();
        }
      })
      .catch((error) => {
        sendDatadogError(error);
        hasNoResultsRef.current = true;
      });
  };

  return {
    clearPredictions,
    getAutocompletePredictions,
    hasNoResultsRef,
    placePredictions,
  };
};
